import {FileHandler} from "./FileHandler";
import {FileData, FileDataCollection} from "./FileData";
import { Store } from 'vuex';

export class UploadHandler {
    public name: string;
    readonly $store: any;
    private plupload!: plupload.Uploader;
    /**
     * All handlers available to the uploader
     */
    private handlers: FileHandler[] = [];
    /**
     * Handlers actually in use by the files
     */
    private usedHandlers: FileHandler[] = [];
    public fileData: FileDataCollection = {};

    public currentFile!: plupload.File | null;

    constructor(name: string, store: Store<any>) {
        this.name = name;
        this.$store = store;

        window.addEventListener('offline', this.pause.bind(this));

        window.addEventListener('online', this.resume.bind(this));
    }

    set uploader(up: plupload.Uploader) {
        this.plupload = up;

        up.bind('BeforeUpload', (up: plupload.Uploader, file: plupload.File) => {
            this.currentFile = file;
        });
    }

    bind(name: string, func: any): void {
        this.plupload.bind(name, func);
    }

    registerHandlers(handlers: FileHandler[]): void {
        for (const i in handlers) {
            handlers[i].setStore(this.$store);
            handlers[i].setFileDataCollection(this.fileData);
            this.handlers.push(handlers[i]);
        }
    }

    queueFile(file: any, data: FileData): void {
        const f: plupload.File = new plupload.File(file);
        for (const i in this.handlers) {
            if (this.handlers[i].isFileOfType(file, data)) {
                data.handler = this.handlers[i];
                if (this.usedHandlers.indexOf(this.handlers[i]) === -1) {
                    this.usedHandlers.push(this.handlers[i]);
                }
                break;
            }
        }
        this.fileData[f.id] = data;
        this.plupload.addFile(f);
    }

    pause(): void {
        if (this.currentFile) {
            this.plupload.stop();
            const fData = this.fileData[this.currentFile.id];
            if (fData.handler) {
                fData.handler.handlePaused(this.plupload, this.currentFile);
            }
        }
    }

    cancelCurrentFile(): void {
        this.plupload.removeFile(this.currentFile);
        this.plupload.stop();
    }

    resume(): void {
        if (this.currentFile) {
            const fData = this.fileData[this.currentFile.id];
            this.currentFile.loaded = fData.chunkOffset!;
            this.currentFile.status = plupload.UPLOADING;
            this.plupload.state = plupload.STARTED;
            this.plupload.trigger('UploadFile', this.currentFile);
            if (fData.handler) {
                fData.handler.handleResume(this.plupload, this.currentFile);
            }
        }
    }
}

export interface UploadHandlerCollection {
    [key: string]: UploadHandler
}
